
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AdminLayout from '@/components/admin/AdminLayout';
import CounselorList from '@/components/admin/counselors/CounselorList';
import ManagePartners from './ManagePartners';

const CareerCounselors = () => {
  return (
    <>
      <Helmet>
        <title>Career Counselors | Admin Portal</title>
      </Helmet>
      
      <Routes>
        <Route path="/" element={
          <AdminLayout>
            <CounselorList />
          </AdminLayout>
        } />
        <Route path="add" element={<ManagePartners type="Career Counselor" />} />
        <Route path="edit/:id" element={<ManagePartners type="Career Counselor" />} />
      </Routes>
    </>
  );
};

export default CareerCounselors;
